import * as S from './styles'
import { useContext, useState } from 'react'
import { defexContents } from "../../Templates/defexData"

// Images
import nitrogenio from '../../../assets/defex/pri/nitrogenio.jpeg'
import fosforo from '../../../assets/defex/pri/fosforo.jpeg'
import potassio from '../../../assets/defex/pri/potassio.jpeg'
import calcio from '../../../assets/defex/sec/calcio.jpeg'
import magnesio from '../../../assets/defex/sec/magnesio.jpeg'
import enxofre from '../../../assets/defex/sec/enxofre.jpeg'
import boro from '../../../assets/defex/mic/boro.jpeg'
import manganes from '../../../assets/defex/mic/manganes.jpeg'
import zinco from '../../../assets/defex/mic/zinco.jpeg'
import cloro from '../../../assets/defex/mic/cloro.jpeg'
import molibdenio from '../../../assets/defex/mic/molibdenio.jpeg'
import cobre from '../../../assets/defex/mic/cobre.jpeg'
import ferro from '../../../assets/defex/mic/ferro.jpeg'
import { DefexContext } from '../../../context/DefexContext/DefexContext'

const defex: any = {
	"nitrogenio": nitrogenio,
	"fosforo": fosforo,
	"potassio": potassio,
	"calcio": calcio,
	"magnesio": magnesio,
	"enxofre": enxofre,
	"boro": boro,
	"manganes": manganes,
	"zinco": zinco,
	"cloro": cloro,
	"molibdenio": molibdenio,
	"cobre": cobre,
	"ferro": ferro
}

const DefexContent = () => {
	const { selectedTags } = useContext(DefexContext)
	const [selectedTab, setSelectedTab] = useState<string>('pri')

	const handleTabChange = (tab: string) => {
		setSelectedTab(tab)
	}

	const checkTags = (tags: any, selTags: any) => {
		let total = 0

		let sel = selTags.map((s: any) => s.value)

		tags.forEach((d: any) => {
			const totalFoundDef = d.tag.filter((tag: any) => sel.includes(tag))
			if (totalFoundDef.length) {
				total++
			}
		})

		return total
	}

	return (
		<S.DefexContentStyled>
			<S.ContentTabsStyled>
				<ul>
					{defexContents.map((c, i) => {
						let defLengthTotal = 0;
						let excLengthTotal = 0;

						c.elements.forEach(function (n) {
							defLengthTotal += checkTags(n.deficiency, selectedTags)
							excLengthTotal += checkTags(n.excess, selectedTags)
						})

						let total = defLengthTotal + excLengthTotal

						return (
							<li key={i}>
								{
									total ?
										<button className={selectedTab !== c.slang ? 'off' : 'on'} onClick={() => handleTabChange(c.slang)}>{c.classification} ({total})</button> :
										<button className='disabled'>{c.classification} ({total})</button>
								}
							</li>
						)
					})}
				</ul>
			</S.ContentTabsStyled>

			<S.ContentMainStyled>
				{
					defexContents.map((c, i) => {
						let defLengthTotal = 0;
						let excLengthTotal = 0;

						c.elements.forEach(function (n) {
							defLengthTotal += checkTags(n.deficiency, selectedTags)
							excLengthTotal += checkTags(n.excess, selectedTags)
						})

						let total = defLengthTotal + excLengthTotal
						let num = 0

						return (
							<section key={i} hidden={(total === 0 || selectedTab !== c.slang)}>
								{c.elements.map((n, ni) => {
									let defLengthTotal = 0;
									let excLengthTotal = 0;


									defLengthTotal += checkTags(n.deficiency, selectedTags)
									excLengthTotal += checkTags(n.excess, selectedTags)

									let total = defLengthTotal + excLengthTotal

									return total !== 0 ? (
										<div key={ni} hidden={total === 0}>
											<h2>{n.element}</h2>
											<div className='nutrient'>
												<div className='text'>
													<h3>Excesso</h3>
													<ul>
														{
															n.excess.map((e, ei) => {
																const totalFound = e.tag.filter((tag: any) => selectedTags.map(s => s.value).includes(tag))

																if (totalFound.length) {
																	num++
																}

																return (
																	<li key={ei}>
																		{
																			totalFound.length ? (
																				<>({num}) <strong>{e.message}</strong></>
																			) : (
																				<span>{e.message}</span>
																			)
																		}
																	</li>
																)
															})
														}
													</ul>
												</div>
												<div key={ni} className='image'>
													<img src={defex[n.image]} alt={n.element} />
												</div>
												<div className='text'>
													<h3>Deficiência</h3>
													<ul>
														{
															n.deficiency.map((d, di) => {
																const totalFound = d.tag.filter((tag: any) => selectedTags.map(s => s.value).includes(tag))

																if (totalFound.length) {
																	num++
																}

																return (
																	<li key={di}>
																		{
																			totalFound.length ? (
																				<>({num}) <strong>{d.message}</strong></>
																			) : (
																				<span>{d.message}</span>
																			)
																		}
																	</li>
																)
															})
														}
													</ul>
												</div>
											</div>
										</div>
									) : <div key={ni}></div>
								})}
							</section>
						)
					})
				}
			</S.ContentMainStyled>
		</S.DefexContentStyled>
	)
}

export default DefexContent
